import script from "./FavoritesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FavoritesComponent.vue?vue&type=script&setup=true&lang=js"

import "./FavoritesComponent.vue?vue&type=style&index=0&id=3f0c4a97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f0c4a97"]])

export default __exports__